import { IModelEntity } from '@pit/core';
import { IDtoResourceFaultType } from './dto.resource.fault.type.interface';
import { IDtoResourceFaultPenalty } from './dto.resource.fault.penalty.interface';
import { IDtoMandator } from './dto.mandator.interface';

export interface IDtoResourceFault extends IModelEntity {

    area?: string;
    code?: string;
    description?: string;
    isVisible?: boolean;

    mandator?: IDtoMandator;
    type?: IDtoResourceFaultType;

    penalties?: IDtoResourceFaultPenalty[];

    getFullDescription?: () => string;

}
